// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/debug/debug.scss
// module id = 23
// module chunks = 0